<template>
  <section
    class="user-profile-entity-document-data"
    v-loading.fullscreen.lock="configureLoading"
    :element-loading-text="LoadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-switch
      class="px-4 !mb-2"
      v-if="!getIsMobile"
      v-model="value1"
      active-text="Table View"
      inactive-text="Tab View"
      active-color="var(--brand-500)"
      inactive-color="var(--black-200)"
    ></el-switch>
    <div class="flex items-start gap-3 !pl-4" v-if="value1 && !getIsMobile">
      <div class="border border-card-border rounded-xl !p-3 w-[22%]">
        <el-menu class="el-menu-vertical-demo sidemenu-one list-group sidemenu">
          <el-input class="!mb-3" placeholder="Search" v-model="search_string" clearable></el-input>
          <el-menu-item
            v-for="(val, index) in entityDocumentTemplates"
            class="truncate !p-0 hover:!bg-transparent"
            :key="index"
            border
          >
            <div :class="getClass(val)" @click="templateDocumentsSideMenu(val)">
              <img
                class="!mr-1"
                src="@/assets/img/icons/docs-file.svg"
                alt="icon"
                style="width: 20px; margin-left: 14px"
              />
              {{ val.name | truncate(25, '...') }}
            </div>
          </el-menu-item>
          <br />
        </el-menu>
      </div>
      <div class="!border !border-card-border rounded-xl !p-3 w-3/4">
        <templateSubmittedDataTable
          v-if="showDataofTemplates"
          :isAEntityTemplateData="isAEntityTemplateData"
          :configurableDocumentId.sync="configId"
          :configurableDocumentData.sync="this.viewDataOfTemplates"
          :entityId="this.entityId"
          :entityDataId="this.entityDataId"
        />
      </div>
    </div>
    <el-row v-else-if="(getIsMobile && !value1) || value1 == false">
      <el-col>
        <el-tabs @tab-click="handleClickTab()" type="border-card" class="mt-2">
          <el-tab-pane
            v-for="(val, index) in entityDocumentTemplates"
            :label="val.name"
            :key="index"
            border
            class="sidemenu"
          >
            <UserTemplatesData
              v-if="sendDataToTable"
              :configurableId="val.configurable_document_id"
              :entityIdForTable="entityIdForDataTable"
              :entityDataIdForTable="entityDataIdForDataTable"
            />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </section>
</template>
<script>
  import { bus } from '../../main';
  import { mapGetters } from 'vuex';
  import UserTemplatesData from './userTemplatesDataInEntityProfile.vue';
  const templateSubmittedDataTable = () =>
    import('@/components/templates/templateSubmittedData.vue');
  export default {
    name: 'templates-PreviewTemplate',
    props: ['entityId', 'entityDataId'],
    data() {
      return {
        entityDocumentTemplates: [],
        array: [],
        documentTemplates: [],
        configureLoading: false,
        LoadingText: '',
        is_document_data: false,
        showDataofTemplates: false,
        configurableDocumentId: null,
        isAEntityTemplateData: false,
        configurableDocumentData: null,
        templates: [],
        configId: '',
        value1: true,
        sendDataToTable: false,
        entityIdForDataTable: this.entityId,
        entityDataIdForDataTable: this.entityDataId,
        viewDataOfTemplates: [],
        templatesCount: null,
        search_string: '',
        total: 0,
        currentPage: 1,
        myArray: [],
        pageSize: 5,
        page: 1,
        order_by: null,
      };
    },
    components: {
      UserTemplatesData,
      templateSubmittedDataTable,
    },
    created() {
      bus.$emit('templates-length', {
        templatesCount: this.templates.length,
      });
    },
    async mounted() {
      //  this.fetchEntityDocumets()
      await this.fetchEntityDocumets();
    },
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
      ...mapGetters('configurableDocuments', ['getConfigurableDocumentDataById']),
      ...mapGetters('entities', [
        'getEntityDocumentsDataStatus',
        'getEntityDocumentsData',
        'getEntityDocumentsNotIncludingTemplatesData',
        'getTemplatesFieldsDataFromEntitiesData',
        'getTemplatesFieldsDataFromEntitiesStatus',
      ]),
      getClass() {
        return (data) => {
          if (this.$route.query.documentTemplateId == data.configurable_document_id) {
            return 'list-group-item list-group-item-action active';
          } else {
            return 'list-group-item list-group-item-action';
          }
        };
      },
    },
    methods: {
      handleClickTab() {
        this.sendDataToTable = true;
      },
      async fetchEntityDocumets() {
        try {
          if (!this.entityDataId) return;
          this.configureLoading = true;
          this.LoadingText = 'Fetching Entity Document Templates...';
          this.entityDocumentTemplates = [];
          let params = {
            entity_id: this.entityId,
            entity_data_id: this.entityDataId,
          };
          if (this.search_string) {
            params.search_string = this.search_string;
          }
          await this.$store.dispatch('entities/fetchEntitiesDocuments', params);
          setTimeout(() => {
            this.configureLoading = false;
          }, 600);
          if (this.getEntityDocumentsDataStatus) {
            this.entityDocumentTemplates = this.getEntityDocumentsData;
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Error in fetching entity documents',
            });
          }

          if (this.$route.query && this.$route.query.documentTemplateId) {
            await this.fetchTemplates();
            this.showDataofTemplates = true;
            this.configId = this.$route.query.documentTemplateId;
            this.configurableDocumentData = this.getConfigurableDocumentDataById;
            this.entityId = this.$route.params.entity_id;
            this.entityDataId = this.$route.query.dataId;
            this.isAEntityTemplateData = true;
          }
          this.fetchTemplates();
        } catch (err) {
          console.log('fetchEntityDocumets', err);
        }
      },

      async templateDocumentsSideMenu(data) {
        this.configureLoading = true;
        this.LoadingText = 'Fetching Document Data...';
        this.showDataofTemplates = false;
        this.configureLoading = false;
        let newPath = `/entity/view/${this.$route.params.entity_id}?dataId=${
          this.entityDataId || ''
        }&activeTab=${this.$route.query.activeTab}&documentTemplateId=${
          data.configurable_document_id
        }`;

        if (this.$route.fullPath !== newPath) {
          this.$router.push({ path: newPath });
        } else {
          console.log('Navigation cancelled: already on the same route.');
        }
        this.configId = data.configurable_document_id
          ? data.configurable_document_id
          : this.$route.query.documentTemplateId;
        await this.fetchEntityDocumets();
      },
      async fetchTemplates() {
        try {
          this.configureLoading = true;
          this.LoadingText = 'Fetching Template Documents Data...';
          let configurable_document_id = this.$route.query.documentTemplateId;
          await this.$store.dispatch('configurableDocuments/fetchConfigurableDocumentById', {
            id: configurable_document_id,
          });
          this.configureLoading = false;
          this.viewDataOfTemplates = this.getConfigurableDocumentDataById;
        } catch (err) {
          console.log('fetchTemplates', err);
        }
      },
      async fetchingSubmittedTemplatesData(data) {
        await this.fetchTemplates();
        this.configureLoading = true;
        this.LoadingText = 'Fetching Template Documents Data...';
        this.showDataofTemplates = true;
        if (data && data.configurable_document_id) {
          this.isAEntityTemplateData = true;
          this.configurableDocumentId = data.configurable_document_id;
          this.configurableDocumentData = this.viewDataOfTemplates;
          bus.$emit('document-change', {
            configurableDocumentId: data.configurable_document_id
              ? data.configurable_document_id
              : this.$route.query.documentTemplateId,
            configurableDocumentData: this.getConfigurableDocumentDataById,
            isAEntityTemplateData: this.isAEntityTemplateData,
          });
        }
        this.configureLoading = false;
      },
    },
    watch: {
      search_string: function (val) {
        this.search_string = val;
        this.fetchEntityDocumets();
      },
      '$route.query.documentTemplateId'(step) {
        let data =
          this.entityDocumentTemplates &&
          this.entityDocumentTemplates.length &&
          this.entityDocumentTemplates.filter((el) => {
            if (el && el.configurable_document_id === step) {
              this.isAEntityTemplateData = true;
              this.myArray.push(el);
              return el;
            }
          });
        if (data && data.length) {
          this.isAEntityTemplateData = true;
          this.fetchingSubmittedTemplatesData(data);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-menu {
    border-right: none !important;
    background: var(--card-color) !important;
  }
  .list-group {
    .list-group-item {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0em;
      border: none;
      color: #9299b8;

      &.active {
        color: var(--brand-500);
        border-left: 3px solid var(--brand-500);
      }
    }
  }
  .sidemenu {
    height: 58dvh;
    overflow: auto;
  }

  .sidemenu::-webkit-scrollbar {
    width: 0.6em;
  }

  .sidemenu::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    background: #ffffff;
    -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
  }

  .sidemenu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f5f5f5;
    background-color: #f5f5f5;
  }
</style>
<style>
  .el-table .cell {
    word-break: break-word;
  }
</style>
